import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useAllAnalysesMode = createGlobalState({
  storage: "session",
  type: io.boolean,
  key: "allAnalysesMode",
  defaultValue: false,
  scoped: true,
});
